import { render } from "./LoginRegister.vue?vue&type=template&id=14bdaf5c"
import script from "./LoginRegister.vue?vue&type=script&lang=js"
export * from "./LoginRegister.vue?vue&type=script&lang=js"
script.render = render

export default script